import { useCallback, useMemo } from 'react';
import { useInstance } from '@milkdown/react';
import { toggleEmphasisCommand, toggleStrongCommand } from '@milkdown/preset-commonmark';
import { createClickFunction } from '../../util/notes';
import { useNotesToolbarContext } from '../../context/notes/notes_toolbar_context';
import { useEditorStateContext } from '../../context/notes/notes_editor_state_context';
import { BOLD_BUTTON_SUFFIX, ITALIC_BUTTON_SUFFIX } from '../../components/notes/consts';
export function useTextEmphasisButtons() {
    const [isLoading, getEditorInstance] = useInstance();
    const { textEmphasisButtonsContext } = useNotesToolbarContext();
    const { captureButtonClick, inCallOrPostCall, readOnlyYn, displayModeYn } = useEditorStateContext();
    const isEmphasisButtonDisabled = readOnlyYn || displayModeYn;
    const handleBoldOnClick = useCallback(() => {
        if (!isLoading) {
            textEmphasisButtonsContext.toggleBoldEmphasisButton();
            const boldClickFunction = createClickFunction(getEditorInstance, isLoading, toggleStrongCommand.key);
            boldClickFunction();
            typeof captureButtonClick === 'function' &&
                captureButtonClick(`${inCallOrPostCall}-${BOLD_BUTTON_SUFFIX}`);
        }
    }, [
        isLoading,
        textEmphasisButtonsContext,
        getEditorInstance,
        captureButtonClick,
        inCallOrPostCall,
    ]);
    const handleItalicOnClick = useCallback(() => {
        if (!isLoading) {
            textEmphasisButtonsContext.toggleItalicEmphasisButton();
            const italicClickFunction = createClickFunction(getEditorInstance, isLoading, toggleEmphasisCommand.key);
            italicClickFunction();
            typeof captureButtonClick === 'function' &&
                captureButtonClick(`${inCallOrPostCall}-${ITALIC_BUTTON_SUFFIX}`);
        }
    }, [
        isLoading,
        textEmphasisButtonsContext,
        getEditorInstance,
        captureButtonClick,
        inCallOrPostCall,
    ]);
    return useMemo(() => {
        return {
            isEditorLoadingYn: isLoading,
            handleBoldOnClick,
            handleItalicOnClick,
            isEmphasisButtonDisabled,
        };
    }, [isLoading, handleBoldOnClick, handleItalicOnClick, isEmphasisButtonDisabled]);
}
//# sourceMappingURL=use_text_emphasis_buttons.js.map